// extracted by mini-css-extract-plugin
module.exports = {"root":"CalendarPage_root__1iflU","mainContent":"CalendarPage_mainContent__3dq_I","heading":"CalendarPage_heading__1hlnE","sidePanel":"CalendarPage_sidePanel__3nWIo"};